var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "domain-supergroups" }, [
    _c("h4", [_vm._v("Supergroups")]),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "text-center py-2" }, [_vm._m(0)])
      : _vm._e(),
    _vm._v(" "),
    _vm.detachError
      ? _c(
          "div",
          {
            staticClass: "alert alert-danger py-1 px-2",
            attrs: { role: "alert" }
          },
          [
            _c("i", { staticClass: "fa fa-exclamation-triangle me-1" }),
            _vm._v("\n    " + _vm._s(_vm.detachError) + "\n  ")
          ]
        )
      : _vm.error
      ? _c(
          "div",
          {
            staticClass: "alert alert-danger py-1 px-2",
            attrs: { role: "alert" }
          },
          [
            _c("i", { staticClass: "fa fa-exclamation-triangle me-1" }),
            _vm._v("\n    " + _vm._s(_vm.error) + "\n  ")
          ]
        )
      : _c("div", [
          _vm.attachedSupergroups.length === 0
            ? _c("div", { staticClass: "text-muted" }, [
                _vm._v("\n      No supergroups attached to this domain.\n    ")
              ])
            : _c(
                "ul",
                { staticClass: "list-group mb-3" },
                _vm._l(_vm.attachedSupergroups, function(supergroup) {
                  return _c(
                    "li",
                    {
                      key: supergroup.uuid,
                      staticClass:
                        "list-group-item d-flex justify-content-between align-items-center"
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(supergroup.name) + "\n        "
                      ),
                      supergroup.type
                        ? _c(
                            "span",
                            { staticClass: "badge bg-secondary me-2" },
                            [_vm._v(_vm._s(supergroup.type))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-outline-danger",
                          attrs: {
                            title: "Detach",
                            disabled: !_vm.canManageSupergroups
                          },
                          on: {
                            click: function($event) {
                              return _vm.detachSupergroup(supergroup)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-times" })]
                      )
                    ]
                  )
                }),
                0
              )
        ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn btn-primary",
        attrs: { disabled: !_vm.canManageSupergroups },
        on: { click: _vm.openModal }
      },
      [
        _c("i", { staticClass: "fa fa-plus me-1" }),
        _vm._v(" Attach Supergroup\n  ")
      ]
    ),
    _vm._v(" "),
    _vm.showModal
      ? _c("div", { staticClass: "modal-backdrop" }, [
          _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button", "aria-label": "Close" },
                    on: { click: _vm.closeModal }
                  },
                  [_c("i", { staticClass: "fa fa-times" })]
                ),
                _vm._v(" "),
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v("Attach Supergroup")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _vm.modalError
                  ? _c(
                      "div",
                      {
                        staticClass: "alert alert-danger",
                        attrs: { role: "alert" }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.modalError) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "mb-3" }, [
                  _c(
                    "label",
                    {
                      staticClass: "form-label",
                      attrs: { for: "supergroupSearch" }
                    },
                    [_vm._v("Search Supergroups")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchQuery,
                        expression: "searchQuery"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      id: "supergroupSearch",
                      placeholder: "Type to search...",
                      autocomplete: "off"
                    },
                    domProps: { value: _vm.searchQuery },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) return
                          _vm.searchQuery = $event.target.value
                        },
                        _vm.searchSupergroups
                      ]
                    }
                  })
                ]),
                _vm._v(" "),
                _vm.searching
                  ? _c("div", { staticClass: "text-center py-2" }, [_vm._m(1)])
                  : _vm.searchResults.length > 0
                  ? _c(
                      "div",
                      { staticClass: "list-group" },
                      _vm._l(_vm.searchResults, function(result) {
                        return _c(
                          "button",
                          {
                            key: result.uuid,
                            staticClass:
                              "list-group-item list-group-item-action",
                            attrs: {
                              disabled: _vm.isSupergroupAttached(result)
                            },
                            on: {
                              click: function($event) {
                                return _vm.selectSupergroup(result)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(result.name) +
                                "\n              "
                            ),
                            result.hierarchy
                              ? _c("small", { staticClass: "text-muted" }, [
                                  _vm._v("(" + _vm._s(result.hierarchy) + ")")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            result.type
                              ? _c("span", { staticClass: "badge" }, [
                                  _vm._v(_vm._s(result.type))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isSupergroupAttached(result)
                              ? _c(
                                  "span",
                                  { staticClass: "badge badge-info" },
                                  [_vm._v("Already attached")]
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    )
                  : _vm.searchQuery && !_vm.searching
                  ? _c("div", { staticClass: "text-muted" }, [
                      _vm._v(
                        "\n            No supergroups found matching your search.\n          "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success",
                    attrs: {
                      type: "button",
                      disabled: _vm.selectedSupergroup === null
                    },
                    on: { click: _vm.attachSupergroup }
                  },
                  [
                    _vm._v("Attach "),
                    _vm.selectedSupergroup
                      ? _c("span", [
                          _vm._v("to " + _vm._s(_vm.selectedSupergroup.name))
                        ])
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button" },
                    on: { click: _vm.closeModal }
                  },
                  [_vm._v("Close")]
                )
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "spinner-border spinner-border-sm text-primary" },
      [
        _c("span", { staticClass: "visually-hidden" }, [
          _vm._v("Loading supergroups...")
        ])
      ]
    )
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "spinner-border spinner-border-sm text-primary" },
      [_c("span", { staticClass: "visually-hidden" }, [_vm._v("Searching...")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }